import _ from 'lodash';
import React from 'react';
import { AllocationBillableTypeFilter, AllocationBookingTypeFilter } from '~/components';
import FiltersGroup from './FiltersGroup';

export default function AllocationFiltersGroup({ filters, onChange }) {
  return (
    <FiltersGroup
      label="Allocation Filters"
      filters={[filters.allocationBookingTypeId, filters.allocationBillableTypes]}>
      {_.has(filters, 'allocationBookingTypeId') && (
        <AllocationBookingTypeFilter
          value={filters.allocationBookingTypeId}
          onChange={({ target: { value } }) => onChange({ allocationBookingTypeId: value })}
        />
      )}

      {_.has(filters, 'allocationBillableTypes') && (
        <AllocationBillableTypeFilter
          value={filters.allocationBillableTypes}
          onChange={({ target: { value } }) => onChange({ allocationBillableTypes: value })}
        />
      )}
    </FiltersGroup>
  );
}
